module.exports = __webpack_public_path__ + "static/architecture-ade2cd44293f1a7294629057073c52b6.png";